import * as React from "react";
import * as i from "../../../../../contracts";
import { CardPropsHandlers } from "../../../../../typings";
import { renderFavoritesIcon, renderGameState, renderTeam, renderLiveStreamingIcon } from "../../EventCard/RenderMethods";
import { renderMiniLiveScore } from "../RenderMethods";
import { BaseDict } from "../../../dict";
import { getDictPhrase } from "../../../../../helpers";

export const renderMiniCardDetails = (event: i.Event, handlers: CardPropsHandlers, showFavorites: boolean, componentPrefix: string, dict: BaseDict) => {
    const classNames = `rj-ev-list__${componentPrefix}__section rj-ev-list__${componentPrefix}__event-info`;

    return (
        <a href={event.linkUrl}
            onClick={handlers.eventCard}
            className={`${classNames}`}
            key={`${componentPrefix}__event-info__${event.id}`}
            data-uat="event-details">

            <div className={`rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__names`} data-uat={`div-ev-list-${componentPrefix}-names`}>
                {renderTeam(event, "1", componentPrefix)}
                {renderTeam(event, "2", componentPrefix)}
            </div>

            <div className={`rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__clock`} data-uat={`div-ev-list-${componentPrefix}-clock`}>
                {renderGameState(event.isLive, event.id, event.gamePart, event.gameTime, componentPrefix, dict)}
            </div>

            <div className={`rj-ev-list__${componentPrefix}__scores`} data-uat={`div-ev-list-${componentPrefix}-scores`}>
                {showFavorites && renderFavoritesIcon(event.isInFavorites, handlers.favorites)}
                {renderLiveStreamingIcon(event.livestreamIcon.active, getDictPhrase(dict, event.livestreamIcon.tooltip), false)}
                {event.isLive && renderMiniLiveScore(event)}
            </div>
        </a>
    )
}